import { Checkbox, Form } from "antd";
import { useTranslation } from "react-i18next";
import { IntegrationEvents } from "../../../api/models";

interface TriggerEventsFormItemProps {
  formDisabled: boolean;
}

export const TriggerEventsFormItem = ({
  formDisabled,
}: TriggerEventsFormItemProps) => {
  const { t } = useTranslation();

  const options = [
    {
      label: t("integrations:trigger-event-power-on"),
      value: IntegrationEvents.ON,
    },
    {
      label: t("integrations:trigger-event-power-off"),
      value: IntegrationEvents.OFF,
    },
    {
      label: t("integrations:trigger-event-position-telemetry"),
      value: IntegrationEvents.POSITION,
    },
  ];

  return (
    <Form.Item
      label={<b>{t("integrations:trigger-events")}</b>}
      name="events"
      data-testid="trigger-events-form-item"
    >
      <Checkbox.Group
        options={options}
        disabled={formDisabled}
        style={{
          display: "flex",
          gap: "6.3em",
        }}
      />
    </Form.Item>
  );
};
